/**
 * Vimeo API - video search
 * Uses VITE_VIMEO_ACCESS_TOKEN
 */

const VIMEO_API_BASE = "https://api.vimeo.com";
const VIMEO_ACCESS_TOKEN = import.meta.env.VITE_VIMEO_ACCESS_TOKEN as string | undefined;

export interface VimeoVideoItem {
  id: string;
  uri: string;
  name: string;
  url: string;
  platform: "vimeo";
  thumbnail?: string;
}

function getThumbFromSizes(sizes: Array<{ link: string }> | undefined): string | undefined {
  if (!sizes?.length) return undefined;
  const idx = sizes.length >= 4 ? 3 : sizes.length >= 3 ? 2 : 1;
  return sizes[idx]?.link ?? sizes[0]?.link;
}

export async function searchVimeoVideos(
  query: string,
  perPage = 10
): Promise<VimeoVideoItem[]> {
  const params = new URLSearchParams({ query: query.trim(), per_page: String(perPage) });
  if (!VIMEO_ACCESS_TOKEN) throw new Error("Missing VITE_VIMEO_ACCESS_TOKEN");
  const res = await fetch(`${VIMEO_API_BASE}/videos?${params}`, {
    headers: {
      Authorization: `Bearer ${VIMEO_ACCESS_TOKEN}`,
      Accept: "application/json",
    },
  });
  if (!res.ok) throw new Error("Vimeo search failed");
  const data = await res.json();
  const list = data.data ?? [];
  return list.map((item: any) => {
    const videoId = (item.uri ?? "").split("/").pop() ?? "";
    const pictures = item.pictures?.sizes;
    return {
      id: videoId,
      uri: item.uri ?? "",
      name: item.name ?? "",
      url: `https://vimeo.com/${videoId}`,
      platform: "vimeo" as const,
      thumbnail: getThumbFromSizes(pictures),
    };
  });
}
